import React from 'react'
import { Box, Button, FormControl, Grid, InputLabel, OutlinedInput, Slide, } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import Dialog from '@mui/material/Dialog';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { updateLanguage } from 'utils/APIs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateLanguage = ({ open, setopenForm, itemName, setselectedRow, getLanguageData }) => {
    const { t } = useTranslation()


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);

        const formData = JSON.stringify({
            name: data.get('name'),
            description: data.get('code'),
        });

        try {
            await updateLanguage(formData, itemName?.id);
            toast.success('Language update Sucessfully');
            getLanguageData()
        } catch (error) {
            toast.error(error.message);
            getLanguageData()
        }

        e.target.reset();
        setopenForm(!open)
    }
    return (
        <div>
            <div>
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Button
                        variant="secondary"

                        onClick={() => setopenForm(!open)}
                        className="text-center"
                    >
                        {t("Close X")}
                    </Button>
                    <MainCard title={t("Update Language")}>
                        <form noValidate onSubmit={handleFormSubmit}>
                            <Grid item>
                                <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-University-Name" shrink>{t("Name")}</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-University-Name"
                                        type="name"
                                        name="name"
                                        label="Name"
                                        notched
                                        inputProps={{}}
                                        value={itemName?.name}
                                        onChange={(e) => setselectedRow({ ...itemName, name: e?.target?.value })}

                                    />
                                </FormControl>
                            </Grid>

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-Description" shrink>{t("Code")}</InputLabel>
                                        <OutlinedInput id="outlined-adornment--Description"
                                            name="code"
                                            label="Code"
                                            notched
                                            inputProps={{}}
                                            value={itemName?.code}
                                            onChange={(e) => setselectedRow({ ...itemName, code: e?.target?.value })}
                                            placeholder="Code"
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 2 }}>
                                <AnimateButton>
                                    <Button fullWidth size="large" type="submit" variant="contained" color="secondary">
                                        {t("Update Language")}
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </form>
                    </MainCard>
                </Dialog>
            </div>
        </div>
    )
}

export default UpdateLanguage